import { isEqual } from "lodash";
import {
  ApplicationBankGuardStatus,
  ApplicationBankGuardStatuses,
  ApplicationBankStatus,
} from "./types";

/** Проверка разрешен ли статус
 * @param status - статус заявки в банк
 * @param allowedStatuses - список разрешенных статусов
 */
export const isStatusAllowed = (
  status: ApplicationBankStatus,
  allowedStatuses: ApplicationBankGuardStatus[]
) => {
  return allowedStatuses.some((allowedStatus) => {
    return (
      allowedStatus.type === status.type &&
      allowedStatus.bank_name === status.bank_name
    );
  });
};

/**
 * Фильтр списка всех статусов. Удаляем из списка запрещенные.
 * @param disabledStatuses - список запрещенных статусов
 * @returns Список разрешенных статусов
 */
export const getStatusesWithoutDisabled = (
  disabledStatuses: ApplicationBankGuardStatus[]
) => {
  return ApplicationBankGuardStatuses.filter((guardStatus) => {
    return !disabledStatuses.some((disabledStatus) => {
      isEqual(disabledStatus, guardStatus);
    });
  });
};
